import {
  AssignedOrgsEntity,
  AssignProjectEntity,
  DefaultEntity,
  ProjectTenantsParams,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class ProjectTenantsService extends BaseService<
  'projectTenants',
  AssignedOrgsEntity,
  DefaultEntity
> {
  constructor() {
    super('project-tenants');
  }

  assignToOrgs = (
    payload: AssignProjectEntity,
  ): Promise<{
    failed: string[];
    success: { [projectId: string]: { failed: string[]; success: string[] } };
  }> => {
    return APIService.post(this.path, payload);
  };

  getAssignedOrgs = (
    params: ProjectTenantsParams,
  ): Promise<AssignedOrgsEntity[]> => {
    const { projectId } = params;
    return APIService.get(this.path + `/${projectId}`);
  };
}

export const projectTenantsService = new ProjectTenantsService();
